import { BaseModal } from 'components/Toolkit/Modal/BaseModal';
import { PricePerMonthModalProps } from 'components/PageWrappers/AdDetails/components/AdTitleBox/AdTitleBox.typed';
import { Button } from 'components/Toolkit/Button';
import { generateFinanceLink } from 'components/PageWrappers/AdDetails/helpers';
import * as Styled from 'components/PageWrappers/AdDetails/components/AdTitleBox/PricePerMonthModal/PricePerMonthModal.styled';

const PricePerMonthModal = (props: PricePerMonthModalProps) => {
  const { close, isOpen, financeInfo } = props;

  const handleButtonClick = () => {
    const redirectUrl = generateFinanceLink(financeInfo);

    if (financeInfo.external) {
      window.open(redirectUrl, '_blank', 'noopener');
    } else {
      window.open(redirectUrl);
    }
  };

  return (
    <BaseModal isOpen={isOpen} askToClose={close}>
      <Styled.Header variant="DEFAULT" shouldTruncate={false} flip={false}>
        {financeInfo.pricePerMonth.title}
      </Styled.Header>

      <Styled.Body
        dangerouslySetInnerHTML={{
          __html: financeInfo.pricePerMonth.displayText,
        }}
      />

      <Button onClick={handleButtonClick} ofType="PRIMARY">
        {financeInfo?.pricePerMonth.buttonText}
      </Button>
    </BaseModal>
  );
};

export { PricePerMonthModal };
